<div class="flex h-screen overflow-hidden">
  <app-aside-nav></app-aside-nav>

  <div class="w-full h-screen overflow-scroll">
    <app-navbar/>
    <app-safe-zone class="relative">
      <ng-content class="bg-white"></ng-content>
    </app-safe-zone>
  </div>
</div>
